import * as swcHelpers from '@swc/helpers';
import { actions } from '@grandvisionhq/state';
import '../actions.js';
import { defaultState } from './state.js';
import { updatePrescriptionValue, updatePrescriptionRecognitionValues, updateUploadReference, removeUploadReference, updatePrescriptionInfo } from '../configurations/actions.js';

var reducer = actions.reducer(defaultState, actions.on(updatePrescriptionValue, (s, { payload  })=>swcHelpers.objectSpread({}, s, {
        [payload.side]: swcHelpers.objectSpread({}, s[payload.side], {
            [payload.parameter]: payload.value
        })
    })
), actions.on(updatePrescriptionRecognitionValues, (s, { payload  })=>swcHelpers.objectSpread({}, s, {
        left: payload.left,
        right: payload.right
    })
), actions.on(updateUploadReference, (s, { payload  })=>swcHelpers.objectSpread({}, s, {
        uploadReferences: swcHelpers.objectSpread({}, s.uploadReferences || {}, {
            [payload.scope]: payload.uploadReference
        })
    })
), actions.on(removeUploadReference, (s, { payload  })=>{
    const _ref = s.uploadReferences || {}, _scope = payload.scope, remainingScopes = swcHelpers.objectWithoutProperties(_ref, [
        _scope
    ].map(swcHelpers.toPropertyKey));
    return swcHelpers.objectSpread({}, s, {
        uploadReferences: remainingScopes
    });
}), /**
   * Changes the prescription expiry date for the given frameSku
   */ actions.on(updatePrescriptionInfo, (s, { payload  })=>{
    return swcHelpers.objectSpread({}, s, {
        additionalInfo: payload.value
    });
}));

export { reducer };
//# sourceMappingURL=reducer.js.map
